import type { SystemStyleObject } from '@chakra-ui/react';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NamedWidget, useFormApi } from 'lib-node-amb-renderer';

import ChakraAlert from '~/common/components/Alerts/Alert/Alert';
import AlertDescription from '~/common/components/Alerts/AlertDescription';
import AlertTitle from '~/common/components/Alerts/AlertTitle';
import Box from '~/common/components/Box';

export class EffectiveDateAlertClass extends NamedWidget {
  constructor(props) {
    super(props);
  }
}

type EffectiveDateAlertProps = {
  sx?: SystemStyleObject;
};

const EffectiveDateAlert = ({ sx }: Readonly<EffectiveDateAlertProps>) => {
  const { getState } = useFormApi();

  const { values } = getState();

  const dateForScreenData = new Date(
    new Date(values?.titleCommitmentDatePlus180).setHours(0, 0, 0, 0),
  ).toDateString();

  const alertColor = 'orange.600';
  const alertBackground = 'orange.100';
  const alertIcon = faExclamationTriangle;
  const title = 'Warning';
  const message = `Based on the estimated closing date, the title commitment may expire.
  If closing after ${dateForScreenData} , must condition for a new title commitment.`;

  return (
    <ChakraAlert
      border="1px solid"
      borderColor={alertColor}
      background={alertBackground}
      borderRadius="4px"
      w="100%"
      mb="1rem"
      sx={sx}
    >
      <Box color={`${alertColor}`} mr={2}>
        <FontAwesomeIcon icon={alertIcon} />
      </Box>

      <AlertTitle mr={4} fontSize="sm" color={alertColor} whiteSpace="nowrap">
        {title}
      </AlertTitle>

      <AlertDescription fontSize="sm" lineHeight="24px">
        {message}
      </AlertDescription>
    </ChakraAlert>
  );
};

export default EffectiveDateAlert;
